import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { apisHeaders } from "../utils";

export const addInvoice = createAsyncThunk(
  "addInvoice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/invoice/addInvoice`,
        data,
        apisHeaders
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getInvoices = createAsyncThunk(
  "getInvoices",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/invoice/getInvoices`,
        data,
        apisHeaders
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getInvoiceById = createAsyncThunk(
  "getInvoiceById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/invoice/getInvoiceById`,
        data,
        apisHeaders
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateInvoice = createAsyncThunk(
  "updateInvoice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}/invoice/updateInvoice`,
        data,
        apisHeaders
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const invoiceSliceDetails = createSlice({
  name: "invoiceSliceDetails",
  initialState: {
    invoices: [],
    invoiceLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addInvoice.pending, (state) => {
        state.invoiceLoading = true;
        state.error = null;
      })
      .addCase(addInvoice.fulfilled, (state, action) => {
        state.invoiceLoading = false;
        state.invoices.push(action.payload.data);
        state.error = null;
      })
      .addCase(addInvoice.rejected, (state, action) => {
        state.invoiceLoading = false;
        state.error = action.payload;
      })

      .addCase(getInvoices.pending, (state) => {
        state.invoiceLoading = true;
        state.error = null;
      })
      .addCase(getInvoices.fulfilled, (state, action) => {
        state.invoiceLoading = false;
        state.invoices = action.payload.data;
        state.error = null;
      })
      .addCase(getInvoices.rejected, (state, action) => {
        state.invoiceLoading = false;
        state.error = action.payload;
      });
  },
});

export default invoiceSliceDetails.reducer;
